import { render } from "./BnPreloaderForButton.vue?vue&type=template&id=1de1ab9e"
import script from "./BnPreloaderForButton.vue?vue&type=script&lang=js"
export * from "./BnPreloaderForButton.vue?vue&type=script&lang=js"

import "./BnPreloaderForButton.vue?vue&type=style&index=0&id=1de1ab9e&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__